module.exports = __webpack_public_path__ + "img/dianhua1.e89c5584.png";